import { roleService } from '../../services/roleService';
import { ROLE } from './actiontype';

export const roleAction = () => {
	return {
		type: ROLE,
		payload: roleService(),
	};
};
